import { numberWithCommas } from "../../Report_common_function";
import { date_dmy_func, getFixedNumber, loginSystemSetting, loginUserIsCBMAttribRole, loginUserIsFranchisesRole } from "../../../components/Common/CommonFunction";

export let showActualAmount = false;

export const setShowActualAmount = (value) => {
  ;
  showActualAmount = value;
};
const getIsFranchises = () => loginUserIsFranchisesRole() || loginUserIsCBMAttribRole();

// ✅ Dynamically controlled columns
export const columns = () => {
  const isFranchises = getIsFranchises();
  return [
  "Group Name",
  "Sub Group Name",
  "Item Name",
  "SAP Code",
  "Opening Balance",
  "GRN Inward",
  "Sales Return",
  "Sale",
  "Purchase Return",
  "Wastage",
  ...(isFranchises ? ["Tolerance Quantity"] : []),
  "Stock Adjustment",
  "Closing Balance",
  ...(showActualAmount ? [] : ["Closing Amount"]), // hide when checked
  "Actual Stock",
  ...(showActualAmount ? ["Actual Stock Amount"] : []), // show when checked
  "Unit",
];
}

// ✅ make this a function so that it updates dynamically
export const columns_for_ChitaleSweetsAndSnacks = () => [
  "Group Name",
  "Sub Group Name",
  "Item Name",
  "Opening Balance",
  "GRN Inward",
  "IB Purchase",
  "Material Issue",
  "Production",
  "IB Sales",
  "Sales Return",
  "Sale",
  "Purchase Return",
  "Wastage",
  "ReIssue",
  "ReProcess",
  "Stock Adjustment",
  "Closing Balance",
  ...(showActualAmount ? [] : ["Closing Amount"]),  // hide when true
  "Actual Stock",
  ...(showActualAmount ? ["Actual Stock Amount"] : []), // show when true
  "Unit",
];

export const PageHedercolumns = ["Billed by", "Billed to", ""];

export const Rows = (data, showActualAmount = false) => {
  const isFranchises = getIsFranchises();
  const { StockDetails = [] } = data;
  StockDetails.sort((a, b) => a.GSTPercentage - b.GSTPercentage);

  const returnArr = [];
  let TotalOpeningBalance = 0;
  let TotalClosingBalance = 0;
  let TotalGRNInward = 0;
  let TotalSalesReturn = 0;
  let TotalSale = 0;
  let TotalPurchaseReturn = 0;
  let TotalStockAdjustment = 0;
  let TotalActualStock = 0;
  let TotalClosingAmount = 0;
  let TotalActualStockAmount = 0;
  let TotalWastage = 0;
  let TotalToleranceQuantity = 0;

  const safe = (val) => { return (Number(val ?? 0).toFixed(3)); };

  StockDetails.forEach((element, key) => {
    const tableitemRow = [
      `${element.GroupName}`,
      `${element.SubGroupName}`,
      `${element.ItemName}`,
      `${element.SAPCode}`,
      numberWithCommas(safe(element.OpeningBalance)),
      numberWithCommas(safe(element.GRNInward)),
      numberWithCommas(safe(element.SalesReturn)),
      numberWithCommas(safe(element.Sale)),
      numberWithCommas(safe(element.PurchaseReturn)),
      numberWithCommas(safe(element.Wastage)),
      ...(isFranchises ? [numberWithCommas(safe(element.ToleranceQuantity))] : []), // ✅
      numberWithCommas(safe(element.StockAdjustment)),
      numberWithCommas(safe(element.ClosingBalance)),
      ...(showActualAmount ? [] : [numberWithCommas(safe(element.ClosingAmount))]),
      numberWithCommas(safe(element.ActualStock)),
      ...(showActualAmount ? [numberWithCommas(safe(element.ActualStockAmount))] : []),
      `${element.UnitName}`,
    ];

    TotalOpeningBalance += Number(element.OpeningBalance) || 0;
    TotalClosingBalance += Number(element.ClosingBalance) || 0;
    TotalGRNInward += Number(element.GRNInward) || 0;
    TotalSalesReturn += Number(element.SalesReturn) || 0;
    TotalSale += Number(element.Sale) || 0;
    TotalPurchaseReturn += Number(element.PurchaseReturn) || 0;
    TotalWastage += Number(element.Wastage) || 0;
    TotalToleranceQuantity += Number(element.ToleranceQuantity) || 0;
    TotalStockAdjustment += Number(element.StockAdjustment) || 0;
    TotalActualStock += Number(element.ActualStock) || 0;
    TotalClosingAmount += Number(element.ClosingAmount) || 0;
    TotalActualStockAmount += Number(element.ActualStockAmount) || 0;

    returnArr.push(tableitemRow);

    if (key === StockDetails.length - 1) {
      const totalRow = [
        "Total",
        "",
        "",
        "",
        numberWithCommas(safe(TotalOpeningBalance)),
        numberWithCommas(safe(TotalGRNInward)),
        numberWithCommas(safe(TotalSalesReturn)),
        numberWithCommas(safe(TotalSale)),
        numberWithCommas(safe(TotalPurchaseReturn)),
        numberWithCommas(safe(TotalWastage)),
        ...(isFranchises ? [numberWithCommas(safe(TotalToleranceQuantity))] : []), // ✅
        numberWithCommas(safe(TotalStockAdjustment)),
        numberWithCommas(safe(TotalClosingBalance)),
        ...(showActualAmount ? [] : [numberWithCommas(safe(TotalClosingAmount))]),
        numberWithCommas(safe(TotalActualStock)),
        ...(showActualAmount ? [numberWithCommas(safe(TotalActualStockAmount))] : []),
      ];
      returnArr.push(totalRow);
    }
  });

  return returnArr;
};

// ✅ updated to accept showActualAmount parameter
export const Rows_for_ChitaleSweetsAndSnacks = (data, showActualAmount = false) => {

  const { StockDetails = [] } = data;
  StockDetails.sort((a, b) => a.GSTPercentage - b.GSTPercentage);

  const returnArr = [];
  let TotalOpeningBalance = 0;
  let TotalClosingBalance = 0;
  let TotalGRNInward = 0;
  let TotalSalesReturn = 0;
  let TotalSale = 0;
  let TotalPurchaseReturn = 0;
  let TotalStockAdjustment = 0;
  let TotalActualStock = 0;
  let TotalActualStockAmount = 0;
  let TotalClosingAmount = 0;
  let TotalProduction = 0;
  let TotalIBPurchase = 0;
  let TotalIBSale = 0;
  let TotalMaterialIssue = 0;
  let TotalReIssue = 0;
  let TotalReProcess = 0;
  let TotalWastage = 0;
  const safe = (val) => { return (Number(val ?? 0).toFixed(2)); };
  const isSaleSwap = Number(loginSystemSetting()?.ShowChallanOnSalesOrder)
  StockDetails.forEach((element, key) => {
    element.Sale = isSaleSwap ? Number(element.IBSale) : Number(element.Sale)
    element.IBSale = isSaleSwap ? 0 : Number(element.IBSale)

    const tableitemRow = [
      `${element.GroupName}`,
      `${element.SubGroupName}`,
      `${element.ItemName}`,
      numberWithCommas(getFixedNumber(element.OpeningBalance, 3).toFixed(3)),
      numberWithCommas(getFixedNumber(element.GRNInward, 3).toFixed(3)),
      numberWithCommas(getFixedNumber(element.IBPurchase, 3).toFixed(3)),
      numberWithCommas(getFixedNumber(element.MaterialIssue, 3).toFixed(3)),
      numberWithCommas(getFixedNumber(element.Production, 3).toFixed(3)),
      numberWithCommas(getFixedNumber(element.IBSale, 3).toFixed(3)),
      numberWithCommas(getFixedNumber(element.SalesReturn, 3).toFixed(3)),
      numberWithCommas(getFixedNumber(element.Sale, 3).toFixed(3)),
      numberWithCommas(getFixedNumber(element.PurchaseReturn, 3).toFixed(3)),
      numberWithCommas(getFixedNumber(element.Wastage, 3).toFixed(3)),
      numberWithCommas(getFixedNumber(element.ReIssue, 3).toFixed(3)),
      numberWithCommas(getFixedNumber(element.ReProcess, 3).toFixed(3)),
      numberWithCommas(getFixedNumber(element.StockAdjustment, 3).toFixed(3)),
      numberWithCommas(getFixedNumber(element.ClosingBalance, 3).toFixed(3)),
      ...(showActualAmount ? [] : [numberWithCommas(safe(element.ClosingAmount))]),
      numberWithCommas(getFixedNumber(element.ActualStock, 3).toFixed(3)),
      ...(showActualAmount ? [numberWithCommas(safe(element.ActualStockAmount))] : []),
      `${element.UnitName}`,
    ];

    TotalOpeningBalance += Number(element.OpeningBalance) || 0;
    TotalClosingBalance += Number(element.ClosingBalance) || 0;
    TotalMaterialIssue += Number(element.MaterialIssue) || 0;
    TotalGRNInward += Number(element.GRNInward) || 0;
    TotalSalesReturn += Number(element.SalesReturn) || 0;
    TotalSale += Number(element.Sale) || 0;
    TotalPurchaseReturn += Number(element.PurchaseReturn) || 0;
    TotalStockAdjustment += Number(element.StockAdjustment) || 0;
    TotalActualStock += Number(element.ActualStock) || 0;
    TotalActualStockAmount += Number(element.ActualStockAmount) || 0;
    TotalClosingAmount += Number(element.ClosingAmount) || 0;
    TotalProduction += Number(element.Production) || 0;
    TotalIBPurchase += Number(element.IBPurchase) || 0;
    TotalIBSale += Number(element.IBSale) || 0;
    TotalReIssue += Number(element.ReIssue) || 0;
    TotalReProcess += Number(element.ReProcess) || 0;
    TotalWastage += Number(element.Wastage) || 0;
    returnArr.push(tableitemRow);

    if (key === StockDetails.length - 1) {
      const totalRow = [
        "Total",
        "",
        "",
        numberWithCommas(getFixedNumber(TotalOpeningBalance).toFixed(3)),
        numberWithCommas(getFixedNumber(TotalGRNInward).toFixed(3)),
        numberWithCommas(getFixedNumber(TotalIBPurchase).toFixed(3)),
        numberWithCommas(getFixedNumber(TotalMaterialIssue).toFixed(3)),
        numberWithCommas(getFixedNumber(TotalProduction).toFixed(3)),
        numberWithCommas(getFixedNumber(TotalIBSale).toFixed(3)),
        numberWithCommas(getFixedNumber(TotalSalesReturn).toFixed(3)),
        numberWithCommas(getFixedNumber(TotalSale).toFixed(3)),
        numberWithCommas(getFixedNumber(TotalPurchaseReturn).toFixed(3)),
        numberWithCommas(getFixedNumber(TotalWastage).toFixed(3)),
        numberWithCommas(safe(TotalReIssue)),
        numberWithCommas(safe(TotalReProcess)),
        numberWithCommas(getFixedNumber(TotalStockAdjustment).toFixed(3)),
        numberWithCommas(getFixedNumber(TotalClosingBalance).toFixed(3)),
        ...(showActualAmount ? [] : [numberWithCommas(safe(TotalClosingAmount))]),
        numberWithCommas(getFixedNumber(TotalActualStock).toFixed(3)),
        ...(showActualAmount ? [numberWithCommas(safe(TotalActualStockAmount))] : []),
        "",
      ];
      returnArr.push(totalRow);
    }
  });

  return returnArr;
};

export const ReportHederRows = (data) => [
  [
    `From Date: ${date_dmy_func(data.FromDate)}`,
    "",
    ""
  ],
  [
    `To Date: ${date_dmy_func(data.ToDate)}`,

    data.PartyName?.includes("Chitale Sweets and Snacks")
      ? `Category: ${data.Period?.CategoryName}`
      : "",

    ""
  ],
];
